// TimelineFieldUpdateTaskUpdate.logs is [TaskExecLog] while
// TimelineFieldCustomEvent.logs is JSON. GraphQL forbids the same response
// key on a union when the types differ, so custom events are aliased and
// copied back onto params.logs for Vue consumers.

export const TIMELINE_EVENT_FIELDS = `
  id
  title
  message
  activity
  success
  createdAt
  causedBy {
    id displayName deletedAt
  }
  caseId
  caseType {
    id name
  }
  params {
    ... on TimelineFieldCaseNoteChange {
      id
      subject
      body
    }
    ... on TimelineFieldUpdateDocument {
      filename
      url
      contentType
      size
      extension
      id
      eventParams
    }
    ... on TimelineFieldUpdateTasks {
      name
    }
    ... on TimelineFieldUpdateTask {
      description
    }
    ... on TimelineFieldUpdateTaskUpdate {
      description
      logs {
        level message timestamp
      }
      taskId
      success
    }
    ... on TimelineFieldUpdateStateChange {
      from
      to
    }
    ... on TimelineFieldUpdateCaseUpdate {
      changedFields {
        ... on TimelineFieldUpdateRowSingle {
          name
          from
          to
        }
        ... on TimelineFieldUpdateRowDocument {
          name
          fromDocument: from {
            filename
            url
            contentType
          }
          toDocument: to {
            filename
            url
            contentType
          }
        }
        ... on TimelineFieldUpdateRowTable {
          name
          headers
          rows
        }
      }
    }
    ...on TimelineFieldUpdateConversation {
      conversation_id
      recipients {
        display_name
        email
      }
      subject
      body
      author_display_name
      author_email
      author_id
    }
    ... on TimelineFieldCustomEvent {
      customEvent
      scriptName
      customLogs: logs
      output
      metadata
      fullMessage
    }
  }
`

export function attachCustomLogs(event) {
  if (event && event.params && event.params.customLogs !== undefined) {
    event.params.logs = event.params.customLogs
  }
  return event
}

export function normalizeTimelineDays(days) {
  if (!days) {
    return days
  }
  days.forEach(function(day) {
    if (day.events) {
      day.events.forEach(attachCustomLogs)
    }
  })
  return days
}
